import GLightbox from "glightbox";
import {isLoading as loaderIsLoading} from "./common/loader.js";
import {OverlayScrollbars} from "overlayscrollbars";

let currentLightbox;
let osInstance;

document.addEventListener("DOMContentLoaded", () => {
    window.isLoading = loaderIsLoading;
    prefetchForms();
    initPopupForms();
    window.addEventListener("message", handleIframeResize);

    document.addEventListener("click", event => {
        if (event.target.classList.contains("close-modal") && currentLightbox) {
            currentLightbox.close();
        }
    });
});

/**
 * Extract ad platform tracking params from current URL for forwarding to iframe.
 * Covers Google Ads, Meta/Facebook, LinkedIn, Microsoft, TikTok, Twitter, Pinterest, HubSpot, UTM.
 */
const getTrackingParams = () => {
    const params = new URLSearchParams(window.location.search);
    const trackingKeys = [
        "_gl", "gclid", "gad_source", "gbraid", "wbraid", "gclsrc",
        "fbclid", "fb_action_ids", "fb_action_types", "fb_source",
        "li_fat_id",
        "msclkid",
        "ttclid",
        "twclid",
        "epik",
        "hsa_cam", "hsa_grp", "hsa_mt", "hsa_src", "hsa_ad", "hsa_acc",
        "hsa_net", "hsa_ver", "hsa_la", "hsa_ol", "hsa_kw", "hsa_tgt",
        "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_id",
    ];
    const tracking = new URLSearchParams();
    trackingKeys.forEach(key => {
        if (params.has(key)) tracking.set(key, params.get(key));
    });
    return tracking.toString();
};

const prefetchForms = () => {
    if (!Array.isArray(window.popupFormsData) || !window.popupFormsData.length) return;

    const prefetchedUrls = new Set();
    const formUrls = new Set(window.popupFormsData);
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        const href = link.getAttribute("href");
        const formUrl = href.slice(1);
        if (formUrls.has(formUrl) && !prefetchedUrls.has(formUrl)) {
            const tracking = getTrackingParams();
            const url = `${location.origin}/forms/?form_url=${encodeURIComponent(formUrl)}${tracking ? "&" + tracking : ""}`;

            const linkEl = document.createElement("link");
            linkEl.rel = "prefetch";
            linkEl.as = "document";
            linkEl.href = url;
            document.head.appendChild(linkEl);
            prefetchedUrls.add(formUrl);
        }
    });
};

const initPopupForms = () => {
    if (!Array.isArray(window.popupFormsData) || !window.popupFormsData.length) return;
    const formUrls = new Set(window.popupFormsData);
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        const href = link.getAttribute("href");
        const formUrl = href.slice(1);
        if (formUrls.has(formUrl)) {
            link.addEventListener("click", event => {
                event.preventDefault();
                openPopupForm(formUrl);
            });
        }
    });
};

const openPopupForm = (formUrl) => {
    const tracking = getTrackingParams();
    const url = `${location.origin}/forms/?form_url=${encodeURIComponent(formUrl)}${tracking ? "&" + tracking : ""}`;
    window.isLoading(true);
    document.body.classList.add("modal-form");

    currentLightbox = GLightbox({
        elements: [
            {
                content: `
                    <button class="close-modal" onclick="
                        window.parent.postMessage({ action: 'closeForm' }, window.location.origin);
                    "><span class="screen-reader-text">Close</span></button>
                    <div class="popup-content">
                        <iframe
                            src="${url}"
                            frameborder="0"
                            scrolling="no"
                            style="width:100%; height:100%;"
                            onload="window.isLoading(false)"
                        ></iframe>
                    </div>`,
            },
        ],
        width: "820px",
        height: "auto",
        closeButton: true,
        touchNavigation: false,
        loop: false,
        openEffect: "fade",
        closeEffect: "fade",
        draggable: false,
        zoomable: false,
    });

    currentLightbox.on("slide_after_load", () => {
        const inline = document.querySelector(".gslide-inline");
        if (!inline) return;

        if (osInstance) {
            osInstance.destroy();
            osInstance = null;
        }
        osInstance = OverlayScrollbars(inline, {
            scrollbars: {autoHide: "never"},
            overflow: {x: "hidden", y: "scroll"}
        });
    });

    currentLightbox.open();

    currentLightbox.on("close", () => {
        document.body.classList.remove("modal-form");
        window.isLoading(false);
        if (osInstance) {
            osInstance.destroy();
            osInstance = null;
        }
    });
};

const handleIframeResize = (event) => {
    if (event.origin !== location.origin || !currentLightbox) return;
    const {action, height, type, url, message} = event.data;

    if (action === "closeForm") {
        currentLightbox.close();
    }

    if (action === "formSubmitted") {
        // Handle form submission from iframe
        if (type === "redirect" && url) {
            // Close the popup and redirect the parent page
            currentLightbox.close();
            setTimeout(() => {
                window.location.href = url;
            }, 100);
        } else {
            // Just close the popup if no redirect
            currentLightbox.close();
        }
    }

    if (typeof height === "number") {
        const iframe = document.querySelector(".gslide iframe");
        if (iframe) {
            iframe.style.height = `${height}px`;
        }
    }
};
//sync forms in tabs
document.addEventListener("DOMContentLoaded", function () {

    // Parent container for tabbed forms
    const container = document.querySelector(".td-tabs .tabs-content");
    if (!container) return; // no tabs → stop

    // Find all forms inside tabs
    const forms = container.querySelectorAll(".tab .sf-forms");
    if (forms.length < 2) return; // need at least 2 forms to sync
    // Now we can safely attach syncing
    container.addEventListener("input", function (e) {
        const field = e.target;

        // Verify field belongs to a form inside tabs
        if (!field.closest(".tab .sf-forms")) return;

        const name = field.getAttribute("name");
        if (!name) return;

        // Select all fields with the same name across all forms
        const sameFields = container.querySelectorAll(`[name="${name}"]`);

        // Update all but the one being typed in
        sameFields.forEach(f => {
            if (f !== field) {
                f.value = field.value;
            }
        });
    });
});
